import c from "./ghl-ui.es760.js";
import n from "./ghl-ui.es1257.js";
import a from "./ghl-ui.es745.js";
var i = "[object Object]", f = Function.prototype, p = Object.prototype, e = f.toString, u = p.hasOwnProperty, b = e.call(Object);
function O(r) {
  if (!a(r) || c(r) != i)
    return !1;
  var o = n(r);
  if (o === null)
    return !0;
  var t = u.call(o, "constructor") && o.constructor;
  return typeof t == "function" && t instanceof t && e.call(t) == b;
}
export {
  O as default
};
